/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Input } from "@nordcloud/gnui";
import { EstateV2Filter } from "~/generated/graphql";
import { useDisclosure } from "~/hooks";
import { CloudResource } from "../EstateRecordsList/types";
import {
  CloudResourceKeys,
  CloudResourceSelector,
} from "./CloudResourceSelector";

type Props = Omit<
  React.HTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
> & {
  small?: boolean;
  value?: CloudResource;
  onChange: (resource: CloudResource) => void;
  searchFilters: EstateV2Filter;
  sidebarLabelKey?: CloudResourceKeys;
};

export function CloudResourceInput({
  value,
  onChange,
  placeholder = "Resource Name",
  small,
  searchFilters,
  sidebarLabelKey = "name",
  ...others
}: Props) {
  const { isOpen, close, open } = useDisclosure();

  const apply = (resource: CloudResource) => {
    onChange(resource);
    close();
  };

  const displayValue = value?.[sidebarLabelKey]?.toString() ?? "";

  return (
    <>
      <Input
        readOnly
        small={small}
        type="text"
        value={displayValue}
        placeholder={placeholder}
        icon="sidebar"
        onClick={open}
        {...others}
      />
      <CloudResourceSelector
        title="Select Resource"
        labelKey={sidebarLabelKey}
        isOpen={isOpen}
        searchFilters={searchFilters}
        onClose={close}
        onSubmit={apply}
      />
    </>
  );
}
